import React, { useEffect, useRef, memo, useState } from 'react';
import { Card, CardBody, Row, ModalBody, Modal, ModalHeader } from 'reactstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ArrowContainer } from 'react-tiny-popover';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import {
  CALENDAR_COLOR,
  CONTENT_APPROVAL,
  USER_ROLES,
} from 'constants/constants';
import { useEvents } from 'hooks/calendar/index';
import styles from 'styles/Calendar.module.scss';
import ModalRecorded from 'components/Modal/ModalRecorded/ModalRecorded';
import ModalInputAccessCode from 'components/Modal/ModalInputAccessCode';
import PopoverCalendar from 'components/PopoverCalendar/PopoverCalendar';
import classnames from 'classnames';
import ViewEventLearner from './ViewEvent/ViewEventLearner';
import { getThemeColor } from 'store/settings';
import { getSelectedCentre } from 'store/master';
import moment from 'moment';
import CalendarCardLearner from 'modules/Course/CourseDetail/Learner/CalendarCardLearnerNew';
import { FormProvider, useForm } from 'react-hook-form';
import { getViewMode } from 'store/auth';
const LearnerCalendar = ({
  calendarApi,
  setCalendarApi,
  dayCalendarApi,
  onAddEvent,
  getEvents,
}) => {
  const calendarRef = useRef(null);
  const events = useEvents();
  const viewMode = useSelector(getViewMode);
  const [newEvents, setNewEvents] = useState();
  const selectedCentre = useSelector(getSelectedCentre);
  const themeStatus = useSelector(getThemeColor);
  const [changedDate, setChangedDate] = useState(new Date());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let newArray = [];
    events?.map((dt) => {
      if (dt?.extendedProps?.roomStatus == 'RUNNING') {
        newArray.unshift(dt);
      } else {
        newArray.push(dt);
      }
    });
    setNewEvents(newArray);
  }, [events]);

  const calendarOptions = {
    events:
      selectedCentre?.reviewContent === false
        ? events
        : events.filter(
            (event) =>
              event?.extendedProps?.unit?.contentReviewStatus ===
              CONTENT_APPROVAL.APPROVED,
          ),
    plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin],
    initialView: 'dayGridMonth',
    headerToolbar: {
      start: 'sidebarToggle, prev, title, next',
      end: '',
    },
    eventTimeFormat: {
      hour: '2-digit',
      minute: '2-digit',
    },
    eventClassNames({ event: calendarEvent }, info) {
      // const colorName = CALENDAR_COLOR[calendarEvent._def.extendedProps.type];
      const colorName = CALENDAR_COLOR.WEBINAR;
      const datePart = moment(
        calendarEvent?._def.extendedProps?.time?.begin,
      ).format('YYYY-MM-DD');
      const isRunning = events.some((event, index) => {
        return (
          event?.extendedProps?.roomStatus === 'RUNNING' &&
          moment(event?.extendedProps?.time?.begin).format('YYYY-MM-DD') ===
            datePart
        );
      });
      const className = isRunning ? 'leaner_flashit' : '';
      return [className, `bg-light-${colorName} `];
    },

    dayMaxEvents: 1,
    eventMaxStack: 1,

    eventContent(info) {
      return <PopoverCalendar info={info} />;
    },

    dateClick(info) {
      setChangedDate(info.dateStr);
      setOpen(true);
    },

    datesSet(info) {
      const { startStr, endStr } = info;
      getEvents(startStr, endStr);
    },

    ref: calendarRef,
  };

  // ** UseEffect checks for CalendarAPI Update
  useEffect(() => {
    if (calendarApi === null) {
      setCalendarApi(calendarRef.current.getApi());
    }
  }, [calendarApi, dayCalendarApi]);

  return (
    <>
      <div className="daycalendar app-calendar-learner-new">
        <ModalInputAccessCode />
        <ModalRecorded />
        <div
          // className="shadow-none border-0 mb-0 rounded-0"
          className={classnames(
            'shadow-none',
            'border-0',
            'mb-0',
            'rounded-0',
            'learner-calendar',
            styles['learner-calendar'],
          )}
          // style={{ zIndex: 1 }}
        >
          <CardBody
            className="pb-0 learner-dot-more-new pt-0 overflow-hidden"
            style={{
              '--back-color': `${themeStatus}`,
              '--date-box': viewMode == USER_ROLES.INSTRUCTOR ? '20px' : '25px',
              '--date-pad': viewMode == USER_ROLES.INSTRUCTOR ? '1px' : '2.5px',
            }}
          >
            <FullCalendar {...calendarOptions} height={260} />
          </CardBody>
        </div>
        <div data-toggle-ld={open} className={`${styles.asideNav}`}>
          {open && (
            <CalendarCardLearner
              date={changedDate}
              open={open}
              setOpen={setOpen}
            />
          )}
        </div>
      </div>
    </>
  );
};

LearnerCalendar.propTypes = {
  calendarApi: PropTypes.any,
  setCalendarApi: PropTypes.func.isRequired,
  dayCalendarApi: PropTypes.any,
  setDayCalendarApi: PropTypes.func.isRequired,
  onAddEvent: PropTypes.func.isRequired,
  getEvents: PropTypes.func.isRequired,
  calendarsColor: PropTypes.object.isRequired,
};

export default memo(LearnerCalendar);
